import React, { useEffect, useState, useRef } from 'react';
import {
    Container,
    Box,
    Avatar,
    Typography,
    Grid,
    TextField,
    Button,
    Paper,
    Chip,
    Stack,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    InputAdornment,
    IconButton,
    List,
    ListItem,
    ListItemText,
    ListItemAvatar,
    Snackbar,
} from '@mui/material';
import Autocomplete, { createFilterOptions } from '@mui/material/Autocomplete';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';

import { Grid2 } from '@mui/material';
import Config from '../Config.json';
import axios from "axios";
import { useBookContext } from "../contexts/bookContext";
import { Link, Navigate, useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";

import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import CloseIcon from '@mui/icons-material/Close';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';

const AdminPage = () => {
    let navigate = useNavigate();

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [stateSnackBar, setStateSnackBar] = React.useState({
        openSnackBar: false,
        verticalSnackBar: 'bottom',
        horizontalSnackBar: 'center',
    });
    const { verticalSnackBar, horizontalSnackBar, openSnackBar } = stateSnackBar;
    const [messageSnackBar, setMessageSnackbar] = useState('');
    const { userData, isLogin, updateUserInfo, actions } = useBookContext();

    useEffect(() => {
        actions.extendTime(userData);
    }, [userData]);


    

    const handleSnackBarClose = () => {
        setStateSnackBar({ ...stateSnackBar, openSnackBar: false });
    };

    const showSnackBar = (msg) => {
        setMessageSnackbar(msg);
        setStateSnackBar({ ...stateSnackBar, openSnackBar: true })
    }





    return (
        <Container maxWidth="md" sx={{ mt: 5, mb: 5 }}>
            <Paper elevation={3} sx={{ p: 4 }}>
                <Button variant="contained" onClick={() => navigate('/requestCourseList')}
                >
                    골프장 추가요청
                </Button>
                
            </Paper>
            <Snackbar
                anchorOrigin={{ vertical: verticalSnackBar, horizontal: horizontalSnackBar }}
                open={openSnackBar}
                onClose={handleSnackBarClose}
                message={messageSnackBar}
                key={verticalSnackBar + horizontalSnackBar}
                autoHideDuration={5000}
                action={
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.5 }}
                        onClick={handleSnackBarClose}
                    >
                        <CloseIcon />
                    </IconButton>
                }
            />
        </Container>

    )
}
export default AdminPage;